$(document).ready(function(){

	$delay = 200
	$animations = $("div").find("[data-animation='scaledown'], [data-animation='fadeup'], [data-animation='slideup'] , [data-animation='slidedown'] , [data-animation='project-stat'] , [data-animation='team-stat'] ").toArray();
	$animations.reverse();
	$statStart = false;

	initAnimationStates()

	checkAnimations()

	$(window).scroll(scrollHandler)
	$('.team-lineup').on('afterChange', function(event, slick, currentSlide, nextSlide){
		  initAnimationStates()
		  checkAnimations()
		});

	function initAnimationStates()
	{
		$statStart = false
		for(var i = 0; i< $animations.length; i++)
		{
			var $ani = $($animations[i]);
			switch($ani.data('animation'))
			{
				case 'fadeup':
					$ani.addClass('ani-fadeup-start')
					break;
				case 'scaledown':
					$ani.addClass('ani-scaledown-start')
					// console.log('yip')
					break;
				case 'slideup':
					$ani.addClass('ani-slideup-start')
					break;
				case 'slidedown':
					$ani.addClass('ani-slidedown-start')
					break;
				case 'project-stat':
					// $ani.data('final-value',0)
					$ani.attr('data-final-value',0)
					break;
				case 'team-stat':

					$perc = $ani.find('.team-bio__progress-number')
					$perc.data('final-value',0)
					$perc.attr('data-final-value',0)
					$bar =  $ani.find('.team-bio__progress-indicator')
					$bar.removeClass('team-bio__progress-transition')
					$bar.css('width',0)
					// $bar.attr()
					break;
			}
		}
	}

	function checkAnimations()
	{
		var que = 0;
		for(var i = $animations.length - 1; i>=0 ; i--)
		{
			var $ani = $($animations[i]);

			if ( isInView($animations[i]) )
			{

				switch($ani.data('animation'))
				{
					case 'fadeup':
						que++;
						$ani.delay($delay * (que - 1)).queue(function(){
					         $(this).removeClass('ani-fadeup-start').addClass('ani-fadeup-end')
					         $(this).dequeue();
					    });
						break;
					case 'scaledown':
						que++;
						$ani.delay($delay * (que - 1)).queue(function(){
					         $(this).removeClass('ani-scaledown-start').addClass('ani-scaledown-end')
					         $(this).dequeue()
					    });
						break;
					case 'slideup':

						que++;
						$ani.delay($delay * (que - 1)).queue(function(){
					         $(this).removeClass('ani-slideup-start').addClass('ani-slideup-end')
					         $(this).dequeue()
					    });
						break;
					case 'slidedown':

						que++;
						$ani.delay($delay * (que - 1)).queue(function(){
					         $(this).removeClass('ani-slidedown-start').addClass('ani-slidedown-end')
					         $(this).dequeue()
					    });
						break;
					case 'project-stat':

						que++;
						$ani.delay($delay * (que - 1)).queue(function(){

					        countUp($(this))

							var $donut = $(this).find('.donut-value')

							animateDonut($donut)

					        $(this).dequeue()
					    });
						
						break;
					case 'team-stat':
						$statStart = true;
						$ani.delay($delay * (que - 1)).queue(function(){
							$perc = $(this).find('.team-bio__progress-number')
							countUp($perc)
							$bar = $(this).find('.team-bio__progress-indicator')
							$bar.addClass('team-bio__progress-transition')
							$val = Number($bar.data('value'))
							$bar.css('width',$val +'%')
							$(this).dequeue()
						});
						break;
				}
				
				if($ani.data('animation') != 'team-stat')
				{
					$animations.splice(i,1)
				}
			}
		}
	}

	function animateDonut(div)
	{
		var $val = Number(div.data('value'))
		var $max = Number(div.data('max'))
		var $calc = 616 * ( $val / $max )
		div.css('stroke-dashoffset',$calc)
	}

	function countUp(div)
	{
		var countTo = Number(div.attr('data-target-value'))
							  
		$({ countNum: div.attr('data-final-value')}).animate({
			countNum: countTo
		},
		{
			duration: 1000,
		    easing:'linear',
		    step: function() {
		      	div.attr('data-final-value' , Math.floor(this.countNum));
		    },
		    complete: function() {
		     	div.attr('data-final-value' , div.attr('data-target-value'));
		     	// div.data('final-value', div.attr('data-target-value'))
		    }
		}); 
	}

	function scrollHandler()
	{
		checkAnimations();
	}

	function isInView(elem)
	{
		var top = $(elem).offset().top
		var bottom = top + $(elem).outerHeight()
		var viewportTop = $(window).scrollTop()
		var viewportBottom = viewportTop + $(window).height() - 100
		var inview = (bottom > viewportTop && top < viewportBottom)
		var inslider = ($(elem).parents('.slick-slide').length > 0)
		var iscurrent = ($(elem).parents('.slick-current').length > 0)
		return ( (inview && !inslider ) || (inview && iscurrent)|| ($statStart && $(elem).data('animation') == 'team-stat' ))
	}

	$(".projects-grid__cell").mousemove(function(e){
	   var parentOffset = $(this).offset()
	   //or $(this).offset(); if you really just want the current element's offset
	   var relX = Number(e.pageX - parentOffset.left)
	   var relY = e.pageY - parentOffset.top
	   var perX = relX / $(this).width()
	   var perY = relY / $(this).height()

	   var xpos = perX * -16 + 8
	   var ypos = perY * -16 + 8

	   var bg = $(this).find('.project-grid__bg')

	   bg.css('transform', "scale(1.2) translateX("+xpos+"%) translateY("+ypos+"%)" )

	});

	$(".projects-grid__cell").mouseout(function(e){
		var bg = $(this).find('.project-grid__bg')
		bg.css('transform', "scale(1) translateX(0) translateY(0)" )
	});

});